import { ProgramKarsilamaPage } from './../Yonetim/program-karsilama/program-karsilama';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { BekleyenListesiPage } from './../ServisKayit/bekleyen-listesi/bekleyen-listesi';
import { TeslimEdilenListesiPage } from './../ServisKayit/teslim-edilen-listesi/teslim-edilen-listesi';
import { ServisKayitArsivPage } from './../ServisKayit/servis-kayit-arsiv/servis-kayit-arsiv';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Ortak } from './../../providers/ortak';
import { YonetimAnaSayfaPage } from './../Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { GirisPage } from './../giris/giris';
import { StoklarPage } from './../StokIslemleri/stoklar/stoklar';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { Component } from '@angular/core';
import { NavController, MenuController, Platform } from 'ionic-angular';
import { CarilerPage } from '../CariIslemleri/cariler/cariler';
import { IsListesiPage } from '../ServisKayit/is-listesi/is-listesi';
import { PagesProvider } from '../../providers/pages-provider';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  lambdurum = false;
  kullaniciyetkiseviyesi: any;
  aktifKullanici: any;
  TamamlananisSayi: any;
  durumlistesi: any = {};
  timerSubscr: any;
  menuler = [];
 Guncellemevarmi:any;
  Bekleyenis: number = 0;
  Tamamlananis: number = 0;
  constructor(public navCtrl: NavController,
    public menu: MenuController,
    public bllOrtak: BllOrtak,
    public modalCtrl:ModalController,
    public platform:Platform,
    public ortak: Ortak,
  ) {
    this.kullaniciyetkiseviyesi = this.ortak.storagePersonelGetir.Type;
    this.aktifKullanici = this.ortak.storagePersonelGetir.Name
    menu.enable(true);
    this.MenuleriGoruntule();
  }
  ionViewDidLoad() {
    this.isdurumbilgileri();
   this.GuncellemeKontrolEt();
  }


  Cikis() {
    this.navCtrl.setRoot(GirisPage);
  }
  issayfasi() {
    this.navCtrl.push(IsListesiPage)
  }
  servisarsiv() {
    this.navCtrl.push(ServisKayitArsivPage)
  }
  teslimedilenisler() {
    this.navCtrl.push(TeslimEdilenListesiPage)
  }
  parcabekleyen() {
    this.navCtrl.push(BekleyenListesiPage)
  }

  MenuleriGoruntule() {
    var pagesProvider = new PagesProvider();
    pagesProvider.menuler().then(a => {
      var sonuc = <any>a;
      if (this.kullaniciyetkiseviyesi == 2) {// Yönetici ise tüm menüleri yükle
        this.menuler = sonuc.MAIN_MENU;
      }
      else if (this.kullaniciyetkiseviyesi == 1) {// Kasiyer ise
        this.menuler = sonuc.KULLANICI_MENU;
      }
      else if(this.kullaniciyetkiseviyesi==3)
      {
        this.menuler=sonuc.PERSONEL_MENU;
      }

    })
  }
  menuItemClick(item) {
    
    var pagesProvider = new PagesProvider();
    var componentType = typeof item.PAGE_COMPONENT;
    var component;
    if (componentType === "string")
      component = pagesProvider.components[item.PAGE_COMPONENT];
    else
      component = item.PAGE_COMPONENT;
    if (component == GirisPage) {
      //  this.ortak.storeagePersonelCikar();
    }
    this.navCtrl.push(component);
  }
  ionViewDidEnter() {
    let timer = TimerObservable.create(10000, 20000);
    this.timerSubscr = timer.subscribe(t => {
      this.isdurumbilgileri();
    });
  }
  isdurumbilgileri() {

    this.bllOrtak.islemWithoutPost("BekleyenIsler", "", false).then(a => {
      var sonuc = <any>a;
      this.durumlistesi = sonuc.SonucObject;
    }).catch(x => {
    })
  }
  kapat() {
    this.ortak.showConfirmAlert("Uyarı", "Uygulama Kapanacak. Devam etmek istiyor musunuz?").then(k => {

      this.platform.exitApp();
    })
  }
  GuncellemeKontrolEt()
  {

    this.bllOrtak.islemWithoutPost("GuncellemeVarmi", "", false).then(a => {
      var sonuc = <any>a;
      this.Guncellemevarmi = sonuc.SonucObject;
     
      if(this.Guncellemevarmi==0)
      this.SurumNotları();
 
     
    }).catch(x => {
    })
  }
  SurumNotları()
  {
    let modal = this.modalCtrl.create(ProgramKarsilamaPage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();

    });
    modal.present();


  }

 

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts